module.exports = __webpack_public_path__ + "img/crisp-green-logo.c9e573ae.png";